// extracted by mini-css-extract-plugin
export var bodySections = "_7b-8";
export var gray = "_7b-7";
export var green = "_7b-4";
export var iconContainer = "_7b-9";
export var iconWidgetContainer = "_7b-1";
export var phoneIcon = "_7b-2";
export var red = "_7b-5";
export var statusDot = "_7b-3";
export var widgetContainer = "_7b-0";
export var yellow = "_7b-6";